import MyPalettes from './MyPalettes.container';

export default MyPalettes;
